import { Component, type ErrorInfo, type ReactNode } from 'react';
import { initialLocale } from './i18n';
import { text } from '../shared/content';
const title = text(
    'Let’s return to your neighborhood.',
    '重新回到你的街区。',
    '重新回到你的街區。',
    'Volvamos a tu barrio.',
  ),
  body = text(
    'Your confirmed progress is saved on the server. Reload to continue your story.',
    '已确认的进度保存在服务器。重新进入后可以继续你的故事。',
    '已確認的進度保存在伺服器。重新進入後可以繼續你的故事。',
    'Tu progreso confirmado está guardado. Recarga para continuar.',
  ),
  reload = text('Reload neighborhood', '重新进入街区', '重新進入街區', 'Recargar barrio');
export default class ErrorBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  state = { failed: false };
  static getDerivedStateFromError() {
    return { failed: true };
  }
  componentDidCatch(error: Error, _info: ErrorInfo) {
    console.error('Game view failed:', error.message);
  }
  render() {
    if (!this.state.failed) return this.props.children;
    const locale = initialLocale();
    return (
      <div className="public-share-page">
        <section>
          <div className="section-eyebrow">AMERICAN DREAM ONLINE</div>
          <h2>{title[locale]}</h2>
          <p>{body[locale]}</p>
          <button className="button primary full" onClick={() => location.reload()}>
            {reload[locale]}
          </button>
        </section>
      </div>
    );
  }
}
